import {call, put, takeEvery} from "redux-saga/effects";
import Api from "../services/Api";

function* assignJourneySafe(action) {
  const {body, params} = action;
  try {
    const safe = yield call(function () {
      return Api.post(`/intervention/${params.interventionId}/assign-safe/${params.safeId}`, body);
    });
    yield put({type: 'ASSIGN_JOURNEY_SAFE.SUCCESS', safe});
    yield put({type: 'SHOW_NOTIFICATION', notification: {message: 'save.success'}});
    yield put({type: 'HIDE_ASSIGN_SAFE_MODAL'});
    yield put({type: 'FETCH.INTERVENTION.REQUEST', id: params.interventionId});
  } catch (error) {
    yield put({type: 'ASSIGN_JOURNEY_SAFE.FAILURE', error});
  }
}

export function* watchAssignJourneySafe() {
  yield takeEvery('ASSIGN_JOURNEY_SAFE.REQUEST', assignJourneySafe)
}

function* unassignJourneySafe(action) {
  const {params} = action;
  try {
    const safe = yield call(function () {
      return Api.post(`/intervention/${params.interventionId}/unassign-safe/${params.type}`);
    });
    yield put({type: 'UNASSIGN_JOURNEY_SAFE.SUCCESS', safe});
    yield put({type: 'FETCH.INTERVENTION.REQUEST', id: params.interventionId});
  } catch (error) {
    yield put({type: 'UNASSIGN_JOURNEY_SAFE.FAILURE', error});
  }
}

export function* watchUnassignJourneySafe() {
  yield takeEvery('UNASSIGN_JOURNEY_SAFE.REQUEST', unassignJourneySafe)
}




// WEBPACK FOOTER //
// ./src/sagas/safe.js